import styles from "./DayLabel.module.css";

const DayLabel: React.FC<React.HTMLProps<HTMLDivElement>> = ({ children }) => {
  return <div className={styles.root}>{children}</div>;
};

export default DayLabel;
